import { render, staticRenderFns } from "./organism.swatch.swatchTray.vue?vue&type=template&id=0767c275"
import script from "./organism.swatch.swatchTray.vue?vue&type=script&lang=ts"
export * from "./organism.swatch.swatchTray.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports